import { cssClasses } from 'pkg/css/utils';

import * as css from './styles.css';

interface HeadingProps extends React.HTMLAttributes<HTMLHeadingElement> {
	centered?: boolean;
	large?: boolean;
	className?: string;
}

export function Heading({
	centered,
	large,
	children,
	className,
	...rest
}: HeadingProps) {
	return (
		<h3
			className={cssClasses(
				css.heading,
				centered && css.centered,
				large && css.large,
				className
			)}
			{...rest}>
			{children}
		</h3>
	);
}
